import React, { Component } from "react";
import { Link } from "react-router-dom";

import $ from "jquery/dist/jquery.js";
import * as apiConstant from "../../api/apiConstant";
import { Businesses } from "../../config/Helper";
import { getVideoThumbFileName } from "../../config/utils";
import { lang } from "../../config/lang";
import * as UTILS from "../../config/utils";
import logApi from "../../api/logApi";
/****************************************
    Component for left side Block on Blog List/Single Pages
    @author  IMH003
    @date    2020.05.10
    @version 0.1    
 ******************************************/
class SideBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.waitAndEllipsis = this.waitAndEllipsis.bind(this);
    this.ellipsisStyle = this.ellipsisStyle.bind(this);
  }

  componentWillMount() {}

  componentDidMount() {
    setTimeout(this.ellipsisStyle, 400);
  }

  componentDidUpdate() {
    setTimeout(this.ellipsisStyle, 400);
    window.addEventListener("resize", this.waitAndEllipsis);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.waitAndEllipsis);
  }

  componentWillReceiveProps(newProps) {}

  waitAndEllipsis() {
    setTimeout(this.ellipsisStyle, 800);
  }

  ellipsisStyle() {
    window.ellipsisMe(
      "#side_block_" + this.props.business + "_" + this.props.id
    );
  }

  onErrorImageLoad() {
    $("#img_side_" + this.props.business + "_" + this.props.id).attr(
      "src",
      "/assets/images/no_image.png"
    );
  }

  render() {
    return (
      <li>
        {this.props.isListPage === false && (
          <div className="blog side-block d-flex-flex">
            <div className="d-flex-flex">
              <Link
                to={`/blog/${Businesses[this.props.business]}/${this.props.id}`}
              >
                {(this.props.image === undefined ||
                  this.props.image === null) && (
                  <img
                    className="side-img mr-3"
                    src="/assets/images/no_image.png"
                    alt="blog"
                  />
                )}
                {this.props.image !== undefined &&
                  this.props.image !== null && (
                    <img
                      className="side-img mr-3"
                      id={`img_side_${this.props.business}_${this.props.id}`}
                      src={apiConstant.thumbnail(
                        this.props.business,
                        this.props.id,
                        this.props.media_type === 1
                          ? getVideoThumbFileName(this.props.image)
                          : this.props.image
                      )}
                      onError={() => this.onErrorImageLoad()}
                      alt="blog"
                    />
                  )}
              </Link>
              {this.props.media_type === 1 && (
                <a
                  href={apiConstant.desktop(
                    this.props.business,
                    this.props.id,
                    this.props.image
                  )}
                  type="video/mp4"
                  className="play-video video-icon small"
                  onClick={() =>
                    logApi.log({
                      title: this.props.title,
                      lang: localStorage.getItem("language"),
                      type: "동화상",
                    })
                  }
                >
                  <i className="fa fa-play" aria-hidden="true"></i>
                </a>
              )}
            </div>
            <div className="text">
              <a>
                <span className="meta">
                  {lang(Businesses[this.props.business])}
                </span>
              </a>
              <Link
                to={`/blog/${Businesses[this.props.business]}/${this.props.id}`}
              >
                <h3
                  className="ellipsis multiline post-title"
                  id={`side_block_${this.props.business}_${this.props.id}`}
                  caption={this.props.title}
                  dangerouslySetInnerHTML={{
                    __html:
                      this.props.title === undefined ||
                      this.props.title === null
                        ? ""
                        : this.props.title,
                  }}
                />
              </Link>
            </div>
          </div>
        )}
        {this.props.isListPage === true && (
          <div className="blog side-block d-flex-flex">
            <div className="d-flex-flex">
              <Link
                to={`/blog/${Businesses[this.props.business]}/${this.props.id}`}
              >
                {(this.props.image === undefined ||
                  this.props.image === null) && (
                  <img
                    className="side-img mr-3"
                    src="/assets/images/no_image.png"
                    alt="blog"
                  />
                )}
                {this.props.image !== undefined &&
                  this.props.image !== null && (
                    <img
                      className="side-img mr-3"
                      id={`img_side_${this.props.business}_${this.props.id}`}
                      src={apiConstant.thumbnail(
                        this.props.business,
                        this.props.id,
                        this.props.media_type === 1
                          ? getVideoThumbFileName(this.props.image)
                          : this.props.image
                      )}
                      onError={() => this.onErrorImageLoad()}
                      alt="blog"
                    />
                  )}
              </Link>
              {this.props.media_type === 1 && (
                <a
                  href={apiConstant.desktop(
                    this.props.business,
                    this.props.id,
                    this.props.image
                  )}
                  className="play-video video-icon small"
                  onClick={() =>
                    logApi.log({
                      title: this.props.title,
                      lang: localStorage.getItem("language"),
                      type: "동화상",
                    })
                  }
                >
                  <i className="fa fa-play" aria-hidden="true"></i>
                </a>
              )}
            </div>
            <div className="text">
              <a>
                <span className="meta">
                  {lang(Businesses[this.props.business])}
                </span>
              </a>
              <Link
                to={`/blog/${Businesses[this.props.business]}/${this.props.id}`}
              >
                <h3
                  className="ellipsis multiline post-title"
                  id={`side_block_${this.props.business}_${this.props.id}`}
                  caption={this.props.title}
                  dangerouslySetInnerHTML={{
                    __html:
                      this.props.title === undefined ||
                      this.props.title === null
                        ? ""
                        : this.props.title,
                  }}
                />
              </Link>
            </div>
          </div>
        )}
      </li>
    );
  }
}

export default SideBlock;
